export const uk = {
    choose: 'Выбрать'
};
